import { render, staticRenderFns } from "./r-talk-dropdown.vue?vue&type=template&id=1ad66eaf"
import script from "./r-talk-dropdown.vue?vue&type=script&lang=js"
export * from "./r-talk-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad66eaf')) {
      api.createRecord('1ad66eaf', component.options)
    } else {
      api.reload('1ad66eaf', component.options)
    }
    module.hot.accept("./r-talk-dropdown.vue?vue&type=template&id=1ad66eaf", function () {
      api.rerender('1ad66eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/talk/r-talk-dropdown.vue"
export default component.exports